import { debounce } from '../../utils/debounce';
import { showOrderModal } from '../../../components/popups/v1/OrderModal/scripts'

const videoWidgetSettings = typeof videoReviewWidgetSettings !== 'undefined'
  ? videoReviewWidgetSettings // eslint-disable-line no-undef
  : null;

export const initVideoWidget = async () => {
  if (!videoWidgetSettings?.video?.mp4) {
    return;
  }

  if (videoWidgetSettings.params) {
    const requiredParams = {};
    const paramRegex = /^[a-zA-Z0-9_-]+=[a-zA-Z0-9_-]+$/;

    videoWidgetSettings.params.split('&').forEach(param => {
      const trimmedParam = param.trim();

      if (!paramRegex.test(trimmedParam)) {
        return;
      }

      const [key, value] = trimmedParam.split('=');
      requiredParams[key.toLowerCase()] = value.toLowerCase();
    });

    const urlParams = new URLSearchParams(window.location.search);
    const urlParamsMap = {};

    urlParams.forEach((value, key) => {
      urlParamsMap[key.toLowerCase()] = value.toLowerCase();
    });

    for (const [key, value] of Object.entries(requiredParams)) {
      if (urlParamsMap[key] !== value) {
        return;
      }
    }
  }

  const ACTION_TYPES = {
    SCROLL: 'scroll',
    POPUP: 'popup'
  }

  const getAction = (type) => {
    if (!type) {
      return null;
    }

    switch (type) {
      case ACTION_TYPES.SCROLL: {
        const elementScroll = document.querySelector('#price') || document.querySelector('#tariffs');

        if (!elementScroll) {
          return null;
        }

        return debounce(() => {
          window.scrollBy({
            top: elementScroll.getBoundingClientRect().top
          });
        }, 200);
      }

      case ACTION_TYPES.POPUP: {
        return () => showOrderModal({blockName: 'video-widget'});
      }

      default: {
        return null;
      }
    }
  }

  try {
    const { VideoReviewWidget } = await import('@skillbox/video-review-widget');
    const action = getAction(videoWidgetSettings.button?.action)

    const widget = new VideoReviewWidget({
      video: videoWidgetSettings.video,
      button: typeof action === 'function' ? {
        text: videoWidgetSettings.button.text,
        action
      } : null
    });

    widget.on('*', (name, payload) => {
      window.$analytics?.push(`video-widget-${name}`, {
        ...payload,
        buttonAction: videoWidgetSettings.button?.action ?? null
      });
    });

    widget.init();
  } catch (error) {
    error.message = `[Video widget]: ${error.message}`;
    window.Sentry?.captureException(error);
  }
}
